import http from "@/common/http";
import authHeader from "./header";
import { SERVICE_API_URL } from "@/common/config";

const login = (params) => {
  return http.post(SERVICE_API_URL + `/oauth/token`, params, {});
};

const findMyInfoByToken = () =>{
  return http.get(SERVICE_API_URL+`/oauth/me`, {
    headers : authHeader()
  })

}

export default {
  login,
  findMyInfoByToken
};
